import { DatasetField } from "../models/dataset-field";
import { axiosInstance } from "../../utils/axios";
import { Dimension } from "../models/dimension";
import { getVersionedApiUrl } from "../../utils/helpers/ApiResolver";

export function fetchDatasetFields(
  dbId: string,
  awCode: string,
  dataset: string,
  partitionType: string,
  descriptionLanguage: string
): Promise<DatasetField[]> {
  return axiosInstance
    .get(
      `${getVersionedApiUrl(
        "/datasetfields"
      )}/${dbId}/${awCode}/${dataset}?partitionType=${partitionType}&descriptionLanguage=${descriptionLanguage}`
    )
    .then((response) => response.data);
}

export function extractMandatoryDimensionsFromDatasetFields(datasetFields: DatasetField[]): Dimension[] {
  return datasetFields
    .filter((field) => field.dimension?.mandatory)
    .map((field) => field.dimension)
    .sort((a, b) => a.index - b.index);
}

export function extractOptionalDimensionsFromDatasetFields(datasetFields: DatasetField[]): Dimension[] {
  return datasetFields
    .filter((field) => field.dimension !== null && !field.dimension.mandatory)
    .map((field) => field.dimension)
    .sort((a, b) => a.index - b.index);
}

export function extractRichTextsFromDatasetFields(datasetFields: DatasetField[]): DatasetField[] {
  return datasetFields.filter((field) => {
    return field.dimension === null && field.fieldType === "0" && field.textFormatType === "1";
  });
}

export function extractAmountsFromDatasetFields(datasetFields: DatasetField[]): DatasetField[] {
  return datasetFields.filter((field) => {
    return field.dimension === null && field.fieldType === "2" && field.textFormatType === "0";
  });
}
